export default __webpack_public_path__ + "static/media/notificationsIcon.e3fbc1bf.svg";